import { useQuery } from '@tanstack/react-query'
import {
  CircularProgress,
  Dialog, DialogContent, DialogTitle,
  IconButton,
  Table, TableBody, TableCell, TableHead, TableRow,
  Typography,
} from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'

import { governanceApi } from '../services/governance-api'

interface IProps {
  workspaceId: string
  open: boolean
  onClose(): void
}

/**
 * K20 (non-optants) drill-down dialog. Pattern B — full PII.
 * Lists MASSA_ELEGIVEL rows with IS_OPTANT = FALSE, with the SoR source
 * label as origin.
 */
export function NonOptantsDrilldownDialog({ workspaceId, open, onClose }: IProps) {
  const { data, isLoading, isError } = useQuery({
    queryKey: ['governance', 'non-optants-drilldown', workspaceId],
    queryFn: () => governanceApi.nonOptantsDrilldown({ workspaceId, limit: 200 }),
    enabled: open && !!workspaceId,
  })

  const rows = data?.data.rows ?? []

  return (
    <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
      <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Typography variant="h6" component="div">Não-optantes ativos (K20)</Typography>
        <IconButton onClick={onClose} size="small"><CloseIcon /></IconButton>
      </DialogTitle>
      <DialogContent dividers>
        {isLoading && <CircularProgress size={20} />}
        {isError && <Typography color="error">Erro ao carregar não-optantes.</Typography>}
        {data && (
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>CPF</TableCell>
                <TableCell>Nome</TableCell>
                <TableCell>Tipo</TableCell>
                <TableCell>Plano</TableCell>
                <TableCell>Origem</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.map((r, i) => (
                <TableRow key={`${r.person_tax_payer_id}-${i}`}>
                  <TableCell>{r.person_tax_payer_id}</TableCell>
                  <TableCell>{r.person_name ?? '—'}</TableCell>
                  <TableCell>{r.person_type ?? '—'}</TableCell>
                  <TableCell>{r.plan ?? '—'}</TableCell>
                  <TableCell>{r.origin ?? '—'}</TableCell>
                </TableRow>
              ))}
              {rows.length === 0 && (
                <TableRow><TableCell colSpan={5} align="center">Nenhum não-optante.</TableCell></TableRow>
              )}
            </TableBody>
          </Table>
        )}
      </DialogContent>
    </Dialog>
  )
}
